// src/services/analyticsService.js
import axios from 'axios';
import { NODE_BACKEND_API_URL } from '../config';

const ANALYTICS_API_URL = `${NODE_BACKEND_API_URL}/analytics`;

export const analyticsService = {
    // Get complete dashboard summary
    getDashboard: async () => {
        const response = await axios.get(`${ANALYTICS_API_URL}/dashboard`);
        return response.data;
    },

    // Get daily invoice statistics
    getDailyInvoiceStats: async () => {
        const response = await axios.get(`${ANALYTICS_API_URL}/daily-invoice-stats`);
        return response.data;
    },

    // Get daily sales statistics
    getDailySalesStats: async () => {
        const response = await axios.get(`${ANALYTICS_API_URL}/daily-sales-stats`);
        return response.data;
    },

    // Get average invoice value
    getAverageInvoiceValue: async (date = null) => {
        const params = date ? { date } : {};
        const response = await axios.get(`${ANALYTICS_API_URL}/average-invoice-value`, { params });
        return response.data;
    },

    // Get best sellers
    getBestSellers: async (count = 10, date = null, period = null) => {
        const params = { count };
        if (period) {
            params.period = period; // Support for day/week/month
        } else if (date) {
            params.date = date; // Backward compatible with date parameter
        }
        const response = await axios.get(`${ANALYTICS_API_URL}/best-sellers`, { params });
        return response.data;
    },

    // Get top products by period
    getTopProducts: async (period = 'week', count = 5) => {
        const response = await axios.get(`${ANALYTICS_API_URL}/top-products`, {
            params: { period, count }
        });
        return response.data;
    },

    // Get sales by category
    // Supports periods: 'day', 'week', 'month', 'prevMonth'
    getSalesByCategory: async (period = 'month') => {
        const response = await axios.get(`${ANALYTICS_API_URL}/sales-by-category`, {
            params: { period }
        });
        return response.data;
    },

    // Get invoice dates (for DatePicker)
    getInvoiceDates: async (range = 90) => {
        const response = await axios.get(`${ANALYTICS_API_URL}/invoice-dates`, {
            params: { range }
        });
        return response.data;
    },

    // Get sales trend over time
    getSalesTrend: async (days = 7) => {
        const response = await axios.get(`${ANALYTICS_API_URL}/sales-trend`, {
            params: { days }
        });
        return response.data;
    },

    // Get category trend
    getCategoryTrend: async (category, days = 30) => {
        const response = await axios.get(`${ANALYTICS_API_URL}/category-trend`, {
            params: { category, days }
        });
        return response.data;
    },

    // Get payment methods distribution
    getPaymentMethods: async (period = 'week') => {
        const response = await axios.get(`${ANALYTICS_API_URL}/payment-methods`, {
            params: { period }
        });
        return response.data;
    }
};
